/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=auth-guard.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: チャット画面に入る前に、このタブが入口（/entry）を通ったことと
 * BFF セッションが有効であることを確認するガード。
 * ---------------------------------------------------------------------
 */


import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EntryMarker } from '../services/entry-marker';

/**
 * BFFセッションの有効性を確認する。トークンの検証はBFF側で行うため、
 * フロントはBFFセッション情報API（GET /api/auth/session）の応答で判定する。
 * BFFセッションが有効でも、このタブが入口（/entry）を通っていなければ直接アクセスとして弾く
 * （machineGuid がないと認証フローを始められないため、外部アプリからの再遷移を促す）。
 */
export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  if (!inject(EntryMarker).isMarked()) {
    return router.createUrlTree(['/error'], {
      queryParams: { reason: 'direct_access' },
    });
  }
  try {
    const res = await fetch('/api/auth/session', { credentials: 'include' });
    if (!res.ok) {
      throw new Error('unauthenticated');
    }
    return true;
  } catch {
    return router.createUrlTree(['/error'], {
      queryParams: { reason: 'unauthenticated' },
    });
  }
};
